export default __webpack_public_path__ + "e703b1c302e270c92dbd9dc8c3c535cd.svg";